// An eBay case id as a link to the case on eBay (2026-10-28,
// docs/decisions/2026-10-28-ebay-case-refund-decommissioned.md): the open-case
// advice step and the escalated-return warning link the case number with the
// contact card's own builder (ebayLinks.js's ebayCaseUrl()).
import { Fragment } from 'react'
import { Link } from '@mui/material'
import { ebayCaseUrl } from './ebayLinks.js'

export function EbayCaseLink({ caseId, kind = null, testId = 'ebay-case-link' }) {
  return (
    <Link href={ebayCaseUrl(caseId, kind)} target="_blank" rel="noopener noreferrer" data-testid={testId}>{String(caseId)}</Link>
  )
}

// text with every appearance of caseId as that link; the text alone when
// there is no case id or it does not appear.
export function LinkedCaseText({ text, caseId, kind = null, testId }) {
  const id = caseId == null ? '' : String(caseId)
  if (!text || !id || !String(text).includes(id)) return text ?? null
  const parts = String(text).split(id)
  return parts.map((part, i) => (
    <Fragment key={i}>
      {part}
      {i < parts.length - 1 && <EbayCaseLink caseId={id} kind={kind} testId={testId} />}
    </Fragment>
  ))
}
